import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { StarsInput } from "@/components/Stars";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useLang } from "@/context/LanguageContext";
import { CheckCircle2 } from "lucide-react";
import { FindoSpinner } from "@/components/FindoSpinner";

export default function Rate() {
  const { declarationId } = useParams();
  const { t } = useLang();
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!stars) return toast.error(t("rate.chooseNote"));
    setBusy(true);
    try {
      await api(`/declarations/${declarationId}/rate`, { method: "POST", auth: false, body: { stars, comment } });
      setDone(true);
    } catch (err) { toast.error(err.message); } finally { setBusy(false); }
  }

  return (
    <div className="max-w-md mx-auto px-6 py-16 text-center">
      {done ? (
        <div className="animate-fade-up" data-testid="rate-success">
          <div className="mx-auto h-16 w-16 grid place-items-center rounded-2xl bg-teal-100 text-teal-700"><CheckCircle2 size={34} /></div>
          <h1 className="mt-5 font-display text-2xl font-extrabold text-slate-900">{t("rate.successTitle")}</h1>
          <p className="mt-2 text-slate-600">{t("rate.successText")}</p>
          <Link to="/"><Button className="mt-6 rounded-xl font-semibold">{t("rate.home")}</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="rate-form">
          <h1 className="font-display text-2xl font-extrabold text-slate-900">{t("rate.title")}</h1>
          <p className="mt-2 text-slate-600">{t("rate.subtitle")}</p>
          <div className="mt-8 flex justify-center"><StarsInput value={stars} onChange={setStars} /></div>
          <Textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={4} maxLength={500}
            placeholder={t("rate.commentPh")} className="mt-6 rounded-xl resize-none text-left" data-testid="rate-comment" />
          <Button type="submit" disabled={busy} className="mt-4 w-full h-12 rounded-xl font-semibold" data-testid="rate-submit">
            {busy ? <span className="inline-flex items-center gap-1.5"><FindoSpinner size={16} />{t("rate.submitting")}</span> : t("rate.submit")}
          </Button>
        </form>
      )}
    </div>
  );
}
